/** CoStar.Api.Autocomplete.ListingLocation.SubmarketPropertyType */
export var SubmarketPropertyType;
(function (SubmarketPropertyType) {
    SubmarketPropertyType[SubmarketPropertyType["None"] = 0] = "None";
    SubmarketPropertyType[SubmarketPropertyType["Industrial"] = 2] = "Industrial";
    SubmarketPropertyType[SubmarketPropertyType["Office"] = 5] = "Office";
    SubmarketPropertyType[SubmarketPropertyType["Retail"] = 6] = "Retail";
    SubmarketPropertyType[SubmarketPropertyType["Multifamily"] = 11] = "Multifamily";
})(SubmarketPropertyType || (SubmarketPropertyType = {}));
